import { FC } from "react";

export const DotLoading: FC = () => {
  return <div className="dots" />;
};
